export interface IUpdateItem {
    status: number;
    content: string;
}

export interface IAppState {
    aliyunPath: string;
    headerMenuIndex: number;
    lang: string;
    updateContent: IUpdateItem;
}

enum HEADER_MENU {
    /** 首页 */
    HOME,
    /** 文档 */
    API,
    /** 日志 */
    LOG,
    /** 个人 */
    PERSONAL
}

export default HEADER_MENU;